import * as Types from './api/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type PromptMutationVariables = Types.Exact<{
  mutationPayload: Types.Scalars['String']['input'];
}>;

export type PromptMutation = { action: boolean };

export const PromptMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PromptMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'mutationPayload' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'action' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'mutationPayload' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'mutationPayload' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PromptMutation, PromptMutationVariables>;
